import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_HAS_QR_CODE_LINK_REDIRECTS_STEP_VISITED = 'UPDATE_HAS_QR_CODE_LINK_REDIRECTS_STEP_VISITED' as const;

export const updateHasQrCodeLinkRedirectsStepVisited = (visited: boolean) => ({
  data: { visited },
  type: UPDATE_HAS_QR_CODE_LINK_REDIRECTS_STEP_VISITED,
});

export type UpdateHasQrCodeLinkRedirectsStepVisitedResponseAction = DataAction<
  typeof UPDATE_HAS_QR_CODE_LINK_REDIRECTS_STEP_VISITED,
  { visited: boolean }
>;
